<template>
    <div class="container-fluid">

        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Edit Event Detail</h1>
        </div>

        <EventDetailForm :id="this.$route.params.id" :is-new="false"></EventDetailForm>
    </div>

</template>

<script>
import {defineComponent} from 'vue'
import EventDetailForm from '@/components/event/EventDetailForm.vue';


export default defineComponent({
    name: "EventDetailEditPage",
    components: {EventDetailForm}
})
</script>

<style scoped>

</style>
